import * as XLSX from 'xlsx';

interface TagExportRow {
  Nombre: string;
  IMEI: string;
  Placa: string;
  Fuente: string;
  Estado: string;
  Latitud: string;
  Longitud: string;
  Velocidad: string;
  'Último Reporte': string;
  'Última Actualización': string;
}

interface TrazabilidadExportRow {
  Fecha: string;
  Latitud: string;
  Longitud: string;
  Velocidad: string;
  Evento: string;
  'Tipo Evento': string;
  'Distancia (m)': string;
  'Tiempo (s)': string;
  'Vel. Promedio': string;
}

const safe = (v: any): string => (v !== undefined && v !== null ? String(v) : '');
const safeNum = (v: any): string => {
  if (v === undefined || v === null) return '';
  const n = typeof v === 'string' ? parseFloat(v) : v;
  return isNaN(n) ? '' : String(n);
};

const formatDate = (d?: string): string => {
  if (!d) return '';
  if (d.length === 14) {
    return `${d.substring(6,8)}/${d.substring(4,6)}/${d.substring(0,4)} ${d.substring(8,10)}:${d.substring(10,12)}:${d.substring(12,14)}`;
  }
  try { return new Date(d).toLocaleString('es-MX'); } catch { return d; }
};

export const exportTagsToExcel = (tags: any[], filename = 'tags') => {
  const rows: TagExportRow[] = tags.map(t => ({
    Nombre: safe(t.name_device || t.device_name),
    IMEI: safe(t.imei || t.vin),
    Placa: safe(t.plate),
    Fuente: safe(t.fuente),
    Estado: safe(t.estatus),
    Latitud: safeNum(t.latitude),
    Longitud: safeNum(t.longitude),
    Velocidad: safeNum(t.speed),
    'Último Reporte': formatDate(t.dateTime),
    'Última Actualización': formatDate(t.ultima_actualizacion),
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);

  // Auto-width columns
  const colWidths = Object.keys(rows[0] || {}).map(key => ({
    wch: Math.max(key.length, ...rows.map(r => String((r as any)[key] || '').length)) + 2,
  }));
  ws['!cols'] = colWidths;

  XLSX.utils.book_append_sheet(wb, ws, 'Tags');
  XLSX.writeFile(wb, `${filename}_${new Date().toISOString().slice(0,10)}.xlsx`);
};

export const exportTagWithTrazabilidad = (tag: any, trazabilidad: any[], filename?: string) => {
  const wb = XLSX.utils.book_new();

  // Hoja 1: Info del tag
  const tagInfo = [
    { Campo: 'Nombre', Valor: safe(tag.name_device || tag.device_name) },
    { Campo: 'IMEI', Valor: safe(tag.imei || tag.vin) },
    { Campo: 'Placa', Valor: safe(tag.plate) },
    { Campo: 'Estado', Valor: safe(tag.estatus) },
    { Campo: 'Latitud', Valor: safeNum(tag.latitude) },
    { Campo: 'Longitud', Valor: safeNum(tag.longitude) },
    { Campo: 'Velocidad', Valor: safeNum(tag.speed) },
    { Campo: 'Último Reporte', Valor: formatDate(tag.dateTime) },
    { Campo: 'Última Actualización', Valor: formatDate(tag.ultima_actualizacion) },
  ];
  const wsInfo = XLSX.utils.json_to_sheet(tagInfo);
  wsInfo['!cols'] = [{ wch: 22 }, { wch: 40 }];
  XLSX.utils.book_append_sheet(wb, wsInfo, 'Información');

  // Hoja 2: Trazabilidad
  const rows: TrazabilidadExportRow[] = trazabilidad.map(p => ({
    Fecha: formatDate(p.dateTime_blac || p.dateTime_tracksolid || p.fecha_registro),
    Latitud: safeNum(p.latitude),
    Longitud: safeNum(p.longitude),
    Velocidad: safeNum(p.speed),
    Evento: safe(p.event),
    'Tipo Evento': safe(p.tipo_evento),
    'Distancia (m)': safeNum(p.distancia_recorrida),
    'Tiempo (s)': safeNum(p.tiempo_transcurrido),
    'Vel. Promedio': safeNum(p.velocidad_promedio),
  }));

  const wsTraz = XLSX.utils.json_to_sheet(rows);
  const colWidths = Object.keys(rows[0] || {}).map(key => ({
    wch: Math.max(key.length, ...rows.slice(0, 50).map(r => String((r as any)[key] || '').length)) + 2,
  }));
  wsTraz['!cols'] = colWidths;
  XLSX.utils.book_append_sheet(wb, wsTraz, 'Trazabilidad');

  const name = filename || safe(tag.name_device || tag.device_name || 'tag');
  XLSX.writeFile(wb, `${name}_trazabilidad_${new Date().toISOString().slice(0,10)}.xlsx`);
};
